/* TANVI fragrance product pages: start the SCENT STORY / MAIN INGREDIENTS motion when they scroll into view. Added 2026-09-29. */
(function () {
  var nodes = document.querySelectorAll('[data-tv-story], [data-tv-ing]');
  if (!nodes.length) return;
  var show = function (n) { n.classList.add('is-in'); };
  Array.prototype.forEach.call(nodes, function (n) { n.classList.add('is-live'); });
  if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(nodes, show); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.3 });
  // one frame later, so the hidden starting state is painted before the motion begins
  window.requestAnimationFrame(function () { Array.prototype.forEach.call(nodes, function (n) { io.observe(n); }); });
})();
